<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un Tipo de Institución</option>
        <option v-else="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" value="value">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los Tipos de Institución</option>
        <option v-for="TipoInstitucion in TiposInstitucion" :value="TipoInstitucion.Nombre">{{TipoInstitucion.Nombre}}</option>
      </select>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import {mapActions} from 'vuex'
  import axios from 'axios'

  export default
  {
    data(){
      return {
        enumeraciones,
        comun,
        TiposInstitucion:[],
        idDelModelo: -1
      }
    },//Data
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: String
    },//Props
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerTipoInstitucion", { llave: this.idDelInput, valor: this.idDelModelo });
    },
    methods: {
    CargarCatalogoDeTiposInstitucion(){
      let peticion = {
        EsPrueba: comun.EsPrueba,
      }
      axios.post(api.conexion + api.TemisCivil.catalogos.TiposInstitucion, peticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.TiposInstitucion = respuesta.data._TiposInstitucion;
              //Seleccionar el primer TipoInstitución n_n
              this.idDelModelo = this.TiposInstitucion[1].Nombre;
              this.cambiaTipoInstitucionInicial();
              return respuesta.data.TiposInstitucion;
            }
          }).catch(e => {
            console.log(e);
         });
    },//CargarCatalogoDeTramites
    cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerTipoInstitucion", { llave: this.idDelInput, valor: evento.target.value });
        this.$emit("valorParaElPadre", evento);
        },
    cambiaTipoInstitucionInicial: function(){
        this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerTipoInstitucion", { llave: this.idDelInput, valor: this.idDelModelo});
        this.$emit("valorParaElPadre", this.idDelModelo);
      }
    },//Methods
    created() {
      this.CargarCatalogoDeTiposInstitucion();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/TemisCivil/Catalogos/TiposInstitucion.vue